<template>
    <span :uk-tooltip="'title:' + text"><slot/></span>
</template>

<script>
export default {
    name: 'Tooltip',
    props: {
        text: String,
    },
};
</script>

<style lang="scss" scoped></style>
